import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Container, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {HomeOutlined } from "@mui/icons-material";
import Footer from "./Footer";
import Button from "./Button";
import { tokens } from "../../theme";
import { useNavigation } from "../../hooks/useNavigation";

const AccessRestrictedComponent : React.FC =() => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { navigate } = useNavigation();

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: "100vh" }}
    >
      <Container
        component="main"
        maxWidth="md"
        style={{
          paddingTop: "40px",
          paddingBottom: "50px",
          textAlign: "center",
        }}
      >
        <Typography variant="h3" fontWeight="bold" sx={{ m: "0 0 5px 0" }}>
          Sorry, Access Restricted!
        </Typography>
        <Box color={colors.grey[500]}>
          Sorry, You don't have access for current URL.
        </Box>
        <Button
          color="error"
          startIcon={<HomeOutlined />}
          onClick={() => navigate("/")}
        >
          Go to Home
        </Button>
      </Container>
      <Box
        sx={{ position: "fixed", bottom: 0, left: 0, right: 0, borderTop: 5 }}
      >
        <Footer />
      </Box>
    </Grid>
  );
}

export default AccessRestrictedComponent;
